module.exports = __webpack_public_path__ + "static/img/Joash-Papalii.b423bba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Joash-Papalii.jpg
// module id = RuJw
// module chunks = 0